import { createContext, ReactElement, ReactNode, useEffect, useMemo, useState } from 'react';
import { axios } from 'utils/axios';
import { NOVAHEAL_API_KEY } from 'config/env';
import { FeatureFlag, FeatureFlagMap, isFeatureFlagName } from 'types/FeatureFlag';

export const FeatureFlags = createContext<FeatureFlagMap | null>(null);

const axiosOptions = {
  headers: {
    'x-api-key': NOVAHEAL_API_KEY,
  },
};

type Props = {
  children: ReactNode;
};

export const FeatureFlagsProvider = ({ children }: Props): ReactElement => {
  const [features, setFeatures] = useState<FeatureFlagMap>(new Map());

  const contextValue = useMemo(() => features, [features]);

  useEffect(() => {
    const fetchFeatures = async (): Promise<void> => {
      try {
        const { data: featureFlags } = await axios.get<FeatureFlag[]>(
          '/feature-flags',
          axiosOptions
        );
        if (!featureFlags) return;

        const parsedFeatureFlags: FeatureFlagMap = new Map();
        featureFlags.forEach((flag) => {
          if (isFeatureFlagName(flag.name)) {
            parsedFeatureFlags.set(flag.name, flag.isEnabled);
          }
        });

        setFeatures(parsedFeatureFlags);
      } catch (err) {
        throw Error('Feature Flags could not be fetched!');
      }
    };
    fetchFeatures();
  }, []);

  return <FeatureFlags.Provider value={contextValue}>{children}</FeatureFlags.Provider>;
};
